import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useRole } from "../../contexts/RoleContext";
import routing from "../../routing";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { ROLE_COLORS } from "../../constants/roles";

function SharedNav({ collapsed }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { currentRole } = useRole();

  const currentColors = ROLE_COLORS[currentRole];

  const navItems = [
    {
      label: t("Main Dashboard"),
      path: routing.home.path,
      icon: faHome,
    },
  ];

  return (
    <>
      {!collapsed && (
        <Box className="nav-section-header">
          <Typography
            className="nav-section-title"
            sx={{ color: `${currentColors.primary} !important` }}
          >
            {t("General")}
          </Typography>
        </Box>
      )}
      <List sx={{ pt: 0, pb: 0 }}>
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          
          return (
            <ListItem
              key={item.path}
              disablePadding
              sx={{
                margin: "2px 8px",
                borderRadius: "8px",
                width: "auto",
              }}
            >
              <Tooltip title={collapsed ? item.label : ""} placement="right">
                <span style={{ width: "100%" }}>
                  <ListItemButton
                    onClick={() => navigate(item.path)}
                    sx={{
                      justifyContent: collapsed ? "center" : "flex-start",
                      px: collapsed ? 0 : 2,
                      py: 1.25,
                      borderRadius: "8px",
                      minHeight: "44px",
                      backgroundColor: isActive
                        ? currentColors.activeLight
                        : "transparent",
                      "&:hover": {
                        backgroundColor: isActive
                          ? currentColors.activeHover
                          : "rgba(255, 255, 255, 0.06)",
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: collapsed ? "auto" : 40,
                        justifyContent: "center",
                        color: isActive ? currentColors.primary : "#b0b0b0",
                        fontSize: "18px",
                      }}
                    >
                      <FontAwesomeIcon icon={item.icon} />
                    </ListItemIcon>
                    {!collapsed && (
                      <ListItemText
                        primary={item.label}
                        sx={{
                          "& .MuiTypography-root": {
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "0.9375rem",
                            color: isActive ? currentColors.primary : "#e0e0e0",
                            fontWeight: isActive ? 600 : 400,
                          },
                        }}
                      />
                    )}
                  </ListItemButton>
                </span>
              </Tooltip>
            </ListItem>
          );
        })}
      </List>
    </>
  );
}

export default SharedNav;
